module.exports = __webpack_public_path__ + "img/DNADamage-CRC_GSE206552.761bbb81.png";